  getQueryStringAsObject = () => {
    var search = location.search.substring(1);
    if (search == null || typeof(search) == 'undefined' || search == '') {
      return null;
    }
    return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
  };

  getQueryStringParameterValue = (key) => {
    return getQueryStringAsObject()[key];
  };

  getQueryStringFullKeyName = (partialKeyName) => {
    var queryObject = getQueryStringAsObject();
    if (queryObject == null || typeof(queryObject) == 'undefined' || Object.keys(queryObject).length == 0) {
      return null;
    }

    for (const [key, value] of Object.entries(queryObject)) { 
      if (key.includes(partialKeyName)) {
        return key;
      }
    }
    return null;
  };